module.exports = __webpack_public_path__ + "img/3.58835d40.png";